import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { useClient } from '@/hooks/api/useClients'
import { Paths } from '@/routes/paths'
import { useNavigate } from '@tanstack/react-router'
import { ClientDataForm } from './ClientDataForm'
import { ClientHeader } from './ClientHeader'
import { ClientServices } from './ClientServices'

export const SingleClientMain = ({ clientId }: { clientId: string }) => {
  const navigate = useNavigate()
  const { data: client, isLoading: clientLoading } = useClient(clientId)

  if (clientLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-10 w-32" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-96 w-full" />
      </div>
    )
  }

  if (!client) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Cliente no encontrado</p>
        <Button onClick={() => navigate({ to: `${Paths.Management.Clients}` })} className="mt-4">
          Volver a Clientes
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <ClientHeader clientId={clientId} client={client} />
      <ClientDataForm clientId={clientId} client={client} />
      <ClientServices clientId={clientId} />
    </div>
  )
}
